export const environment = {
  production: true,
  apiUrl: 'https://api-pre-prod.paddock-one.com',
  cdn: 'http://cdn.paddock-one.com',
  socketUrl: 'wss://ws-pre-prod.paddock-one.com',
  socketApiCallUrl: 'https://ws-pre-prod.paddock-one.com',
  maxIdleMinute: 60,
  opperateurApvChateaurenard: ['claudy.florimond@synethis.com', 'pierre-yves.valin@synethis.com'],
  responsableApvCavaillon: ['sophie.chambry@synethis.com', 'marie-claire.berg@synethis.com'],
  opperateurApvMontelimarSud: [
    'aristide.bouchon@synethis.com',
    'pascal.manquat@synethis.com',
    'karine.laurent@synethis.com',
    'alisson.jolly@synethis.com',
    'marine.charie@synethis.com',
    'jean.laurette@synethis.com',
    'florie-anne.viet@synethis.com',
  ],
  responsableApvMontelimar: ['pierre-emile.flavenot@synethis.com'],
  opperateurApvDigne: [
    'brandon.lafond@synethis.com',
    'rms.digne@synethis.com',
    'gilles.savarese@synethis.com',
    'julien.boyer@synethis.com',
    'gregory.ebert@synethis.com',
  ],
  responsableApvManosque: ['nicolas.remy@synethis.com'],
  opperateurApvHyeres: [
    'florian.benivady@synethis.com',
    'slimane.gafour@synethis.com',
    'jennifer.suraci@synethis.com',
    'isabelle.schmit@synethis.com',
    'sabrina.zaiane@synethis.com',
    'jennifer.suraci@synethis.com',
    'aurelien.bogaers@synethis.com',
  ],
  responsableApvHyeres: ['laurent.marcantoni@synethis.com', 'emmanuel.busa@synethis.com'],
  opperateurApvPrivas: [''],
  responsableApvAubenas: [''],
  enableDiscordAlert: false,
  appwriteUrl: 'https://cdn.paddock-one.com/v1',
  appwriteProjectId: '63c127124a17806ab460',
};
